module.exports = __webpack_public_path__ + "static/img/example2.ff6d61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example2.jpg
// module id = 708
// module chunks = 1